<div class="fullScreenCenterCenter">
    <div class="w300px">

        <!-- Form inicio sesion instructor -->
        <h6 class="ft16 ft500 centertext">Registro de usuarios instructores</h6>

        <div class="mgt20">
            <input type="text" placeholder="Correo" [(ngModel)]="email" [ngModelOptions]="{standalone: true}" class="fw">
        </div>

        <div class="mgt10">
            <input type="text" placeholder="Contraseña" [(ngModel)]="password" [ngModelOptions]="{standalone: true}" class="fw">
        </div>

        <div class="mgt10">
            <input type="text" placeholder="Nombre" [(ngModel)]="nombre" [ngModelOptions]="{standalone: true}" class="fw">
        </div>

        <div class="mgt10">
            <input type="text" placeholder="Instructor Id" [(ngModel)]="docName" [ngModelOptions]="{standalone: true}" class="fw">
        </div>

        <div>
            <button class="mgt10 darkButton fw" (click)="signUpInstructor()">
                Registrar instructor
            </button>
        </div>

    </div>
</div>